import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { GridApi, GridOptions, IDatasource, IGetRowsParams } from 'ag-grid-community';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { GroupRoleUserDto } from 'projects/shared/src/lib/models/GroupRole';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { ProjectRolesService } from 'projects/shared/src/lib/services/project-roles.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { AgGridUserGroupRolesSettings } from './AgGridUserGroupRolesSettings';
import { UserGroupRolesButtonRendererComponent } from './user-group-roles-button-renderer/user-group-roles-button-renderer.component';
import { AddUserGroupRoleDialogComponent } from '../add-user-group-role-dialog/add-user-group-role-dialog.component';
import { ProjectGroupRoleUser } from 'projects/shared/src/lib/models/SquirrelRoles';

@Component({
  selector: 'user-group-roles-dialog',
  templateUrl: './user-group-roles-dialog.component.html',
  styleUrls: ['./user-group-roles-dialog.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class UserGroupRolesDialogComponent implements OnInit {

  groupRoleId!: string;
  groupRoleName!: string;
  rowData: GroupRoleUserDto[] = [];
  ds!: IDatasource;
  gridApi!: GridApi;
  gridOptions!: GridOptions;
  frameworkComponents: any;
  filter!: GenericFilter;
  aggridSettings!:AgGridUserGroupRolesSettings;
  public overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  tenantdb!:string;
  _db!:string;
  _targetIsTenantDB = true;

  constructor(
    public _dialogRef: MatDialogRef<UserGroupRolesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private projectRoleService: ProjectRolesService,
    private dialog: MatDialog,
    private oauthService: OAuthServiceService,
    private tenantService:TenantService,
    public translate: TranslateService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    this._targetIsTenantDB = this.tenantService.currentTenantName != this.tenantService.SystemManagerAbbreviation;

    this.filter = new GenericFilter();
    this.aggridSettings = new AgGridUserGroupRolesSettings(this.translate);
    console.log("----> UserGroupRolesDialogComponent: this.data = ",this.data)
    this.tenantService.projectId = this.data.projectId;
    this.frameworkComponents = { buttonRenderer: UserGroupRolesButtonRendererComponent };
    this.gridOptions = this.aggridSettings.agGridUserGroupRolesSettings;

    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = data.role as Array<string>;
          userRoles.forEach((dbrole: string) => {
            if (dbrole === 'admin') {
             this._db = dbrole;
            }
          });
        }
      }
    });

    this.ds = {
      rowCount: 0,
      getRows: (params: IGetRowsParams) => {
        this.filter.className = 'Role';
        this.filter.startRow = params.startRow;
        this.filter.endRow = params.endRow;
        this.filter.sortItems = params.sortModel;
        this.filter.clientFilters = params.filterModel;

        this.gridApi.showLoadingOverlay();
        this.isLoadingResults = true;

        if(!this._targetIsTenantDB) {      
          this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["GROUPROLEUSERSRETRIEVEDERROR"]}`)
          // this.projectRoleService.loadGroupRoleUsers(this.data.projectId, this.data.roleId, this.filter).subscribe({
          //   next: (groupRoleUserDtos: GroupRoleUserDto[]) => {

          //     this.rowData = groupRoleUserDtos.slice(this.filter.startRow, this.filter.endRow);
          //     let lastRow = -1;
  
          //     if (this.rowData.length <= this.filter.endRow) {
          //       lastRow = this.rowData.length;
          //     }
          //     params.successCallback(this.rowData, lastRow);
          //      this.isLoadingResults = false;
          //      this.isRateLimitReached = false;
          //      this.resultsLength = this.rowData.length;
   
          //      this.gridApi.hideOverlay();
  
          //     if (this.rowData.length > 0) {
          //       //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["GROUPROLEUSERSRETRIEVED"]} `);
          //     }
          //     else {
          //       this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["NOGROUPROLEUSERSRETRIEVED"]} `);
          //     }
          //   },
          //   error: (error: any) => {
          //     this.isLoadingResults = false;
          //     this.isRateLimitReached = true;
          //     this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["GROUPROLEUSERSRETRIEVEDERROR"]}`)
          //   }
          // });
        }
        else {
          let db:string = this.tenantService.currentTenantName;

          console.log("-----------------> role data=",this.data)

          this.tenantService.fetchTenantGroupRoleUsers(db, this.data.projectId, this.data.roleId, this.filter).subscribe({
            next: (groupRoleUserDtos: GroupRoleUserDto[]) => {
              console.log("-----------------> role users =",groupRoleUserDtos) 
              this.rowData = groupRoleUserDtos.slice(this.filter.startRow, this.filter.endRow);
              this.groupRoleName = this.data.roleName;
              this.groupRoleId = this.data.roleId;
              let lastRow = -1;
  
              if (this.rowData.length <= this.filter.endRow) {
                lastRow = this.rowData.length;
              }
              params.successCallback(this.rowData, lastRow);
               this.isLoadingResults = false;
               this.isRateLimitReached = false;
               this.resultsLength = this.rowData.length;
   
               this.gridApi.hideOverlay();
  
              if (this.rowData.length > 0) {
                //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["GROUPROLEUSERSRETRIEVED"]} `);
              }
              else {
                //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["NOGROUPROLEUSERSRETRIEVED"]} `);
              }
            },
            error: (error: any) => {
              this.isLoadingResults = false;
              this.isRateLimitReached = true;
              this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["GROUPROLEUSERSRETRIEVEDERROR"]}`)
            }
          });
        }
      }
    };
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.setDatasource(this.ds)
  } 

  cancel(){
    this._dialogRef.close();
  }

  // openUserGroupRoleDialog(){
  //   //const rowData = [this.params.node.data];

  //  let projectGroupRoleUser = new ProjectGroupRoleUser;
  // //  console.log("openUserGroupRoleDialog: groupRoleId", this.groupRoleId)
  // //  console.log("openUserGroupRoleDialog: groupRoleName", this.groupRoleName)
  // //  console.log("openUserGroupRoleDialog: projectId", this.data.projectId)
  //  projectGroupRoleUser.roleId = this.groupRoleId;
  //  projectGroupRoleUser.projectId = this.data.projectId;
  //  projectGroupRoleUser.roleName = this.groupRoleName;

  //  const dialogRef = this.dialog.open(AddUserGroupRoleDialogComponent, { width: '500px', data: projectGroupRoleUser });
  //  //this._dialogRef.close();
   
  // }
}
